export default "__VITE_ASSET__B_LJF$CG__"